/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EcdsaSecp256K1VerificationKey2019Type: core.serialization.Schema<
    serializers.EcdsaSecp256K1VerificationKey2019Type.Raw,
    Truvity.EcdsaSecp256K1VerificationKey2019Type
> = core.serialization.enum_(['Multikey', 'EcdsaSecp256k1VerificationKey2019']);

export declare namespace EcdsaSecp256K1VerificationKey2019Type {
    export type Raw = 'Multikey' | 'EcdsaSecp256k1VerificationKey2019';
}
